import React from "react";
import Loading from "../components/Loading";
import { useParams, Link } from "react-router-dom";
import { useGlobalContext } from "../context";
var url = "https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i=";

const SingleCocktail = () => {
  const { idDrink } = useParams();
  const { getSinglecocktail } = useGlobalContext();

  const filtereddata = getSinglecocktail(idDrink)[0];
  console.log(filtereddata);
  return (
    <section className="section cocktail-section">
      <Link className="btn btn-primary" to="/Home">
        back home
      </Link>
      {filtereddata !== undefined && (
        <h2 className="section-title">{filtereddata.strDrink}</h2>
      )}
      <div className="drink">
        <img></img>
      </div>
      <div className="drink">
        {filtereddata === undefined && <Loading></Loading>}
        {filtereddata !== undefined && (
          <>
            <img src={filtereddata.strDrinkThumb} alt="A1"></img>
            <div className="drink-info">
              <p>
                <span className="drink-data">name :</span>{" "}
                {filtereddata.strDrink}
              </p>
              <p>
                <span className="drink-data">category :</span>
                {filtereddata.strCategory}
              </p>
              <p>
                <span className="drink-data">info :</span>
                {filtereddata.strAlcoholic}
              </p>
              <p>
                <span className="drink-data">glass :</span>{" "}
                {filtereddata.strGlass}
              </p>
              <p>
                <span className="drink-data">instructons :</span>
                {filtereddata.strInstructions}
              </p>
              <p>
                <span className="drink-data">ingredients :</span>

                <span> {filtereddata.strIngredient1}</span>
                <span> {filtereddata.strIngredient2}</span>
                <span> {filtereddata.strIngredient3}</span>
                <span>{filtereddata.strIngredient4}</span>
                <span> {filtereddata.strIngredient5}</span>
                <span> {filtereddata.strIngredient6}</span>
                <span> {filtereddata.strIngredient7}</span>
                <span>{filtereddata.strIngredient8}</span>
                <span> {filtereddata.strIngredient9}</span>
                <span> {filtereddata.strIngredient10}</span>
                <span> {filtereddata.strIngredient11}</span>
                <span>{filtereddata.strIngredient12}</span>
                <span> {filtereddata.strIngredient13}</span>
                <span> {filtereddata.strIngredient14}</span>
                <span>{filtereddata.strIngredient15}</span>
              </p>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default SingleCocktail;
